<script setup>
import { defineProps } from 'vue';
import IconEyeOpen from '../icons/IconEyeOpen.vue';
import PreviewTemplate from './Template.vue';

defineProps({
  logo: {
    type: String,
    required: true
  },
  links: {
    type: Array
  }
});
</script>

<template>
  <preview-template :logo="logo" header-text="Log In">
    <template #header-content>
      <h2>Login Preview</h2>
    </template>

    <template #form-content>
      <div class="form-group">
        <div class="form-input">
          <span class="form-input__label">Email address <span>*</span></span>
          <div/>
        </div>
        <div class="form-input">
          <span class="form-input__label">Password <span>*</span></span>
          <div class="password">
            <icon-eye-open class="eye"/>
          </div>
        </div>
      </div>
      <div class="documents">
        <p>
          By clicking LOG IN, I acknowledge I have read and agree to the governing documents listed below:
        </p>
        <div class="form-links">
          <div>
            <span>Terms of Service Agreement</span>
          </div>
          <div v-for="(link, index) in links" :key="index">
            <span>{{ link.title }}</span>
          </div>
        </div>
      </div>
      <div class="form-actions">
        <div>Log In</div>
      </div>
    </template>

    <template #form-footer>
      <div class="login-register">
        <p class="login-register__link">Forgot Password</p>
        <p>Don’t have an account? <span class="login-register__link">Create one now</span></p>
      </div>
    </template>
  </preview-template>
</template>

<style lang="scss" scoped>
.form-group {
  display: flex;
  flex-direction: column;
  row-gap: 20px;
  margin-bottom: 26px;
}

.form-input {
  position: relative;
  width: 100%;

  &__label {
    background-color: #fff;
    color: #000;
    position: absolute;
    top: -10px;
    left: 15px;
    display: inline-block;
    width: auto;
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 20px;
    padding: 0 5px;
    z-index: 50;
    cursor: default;

    span {
      color: #ff0000;
    }
  }

  div {
    border: 1px solid #9B9B9B;
    border-radius: 5px;
    width: 100%;
    padding: 23px;
  }

  .password {
    position: relative;
    .eye {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 4px;
    }
  }
}

.documents {
  margin-bottom: 20px;
  .form-links {
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
    text-align: center;
  }

  .form-links span {
    color: #3d66be;
    margin: 0 5px;
  }

  .form-links > div {
    margin-bottom: 5px;
  }
}
.documents p {
  font-size: 14px;
  line-height: 1.3;
}

.form-actions {
  display: flex;
  grid-column-gap: 16px;
  flex-wrap: wrap;
  justify-content: center;

  div {
    background-color: #583174;
    font-size: 14px;
    padding: 10px 24px;
    color: #ffffff;
    border: 0;
    width: 180px;
    height: 40px;
    border-radius: 50px;
    text-align: center;
  }
}

.login-register {
  margin-top: 10px;
  text-align: center;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;

  p {
   margin: 10px 0 0; 
  }

  &__link {
    color: #583174;
  }
}
</style>
